import { Component } from '@angular/core';
import {PurgeService} from './purge.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AlertService} from 'ng-jhipster';

@Component({
    selector: 'jhi-purge',
    templateUrl: './purge.component.html'
})
export class PurgeComponent {

    campaignYear: string;
    purged: boolean;

    constructor(
        private modalService: NgbModal,
        private purgeService: PurgeService,
        private alertService: AlertService
    ) {}

    submitPurge(purgeCampaignPopup: string) {
        this.purged = null;
        this.open(purgeCampaignPopup);
    }

    open(purgeCampaignPopup: string) {
        this.modalService.open(purgeCampaignPopup).result.then((result) => {
            this.purgeService.purge(this.campaignYear).subscribe(
                this.onSaveSuccess,
                this.onSaveError);
        }, (reason) => {
            this.onSaveError(reason);
        });
    }

    // this binding
    onSaveSuccess = () => {
        this.purged = true;
    }

    // this binding
    onSaveError = (error) => {
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/purge/purge.component.ts